import { useEffect, useState } from "react";
import { CONFIG, goToCheckout } from "../../config";
import { X, Gift } from "lucide-react";
import { useI18n } from "../../i18n";

export default function ExitIntent() {
  const [open, setOpen] = useState(false);
  const { t, currency, fmtCcy } = useI18n();

  useEffect(() => {
    if (sessionStorage.getItem("ei_shown")) return;
    let armed = false;
    const tm = setTimeout(() => { armed = true; }, 8000);
    const onLeave = (e) => {
      if (!armed) return;
      if (e.clientY <= 4) {
        sessionStorage.setItem("ei_shown", "1");
        setOpen(true);
        document.removeEventListener("mouseleave", onLeave);
      }
    };
    const onScroll = () => {
      if (!armed) return;
      const p = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (p > 0.6 && !sessionStorage.getItem("ei_shown")) {
        sessionStorage.setItem("ei_shown", "1");
        setOpen(true);
      }
    };
    document.addEventListener("mouseleave", onLeave);
    window.addEventListener("scroll", onScroll);
    return () => {
      clearTimeout(tm);
      document.removeEventListener("mouseleave", onLeave);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  if (!open) return null;
  return (
    <div data-testid="exit-intent"
      className="fixed inset-0 z-[80] grid place-items-center bg-black/70 backdrop-blur-md p-4"
      onClick={() => setOpen(false)}>
      <div onClick={(e) => e.stopPropagation()} className="panel p-6 sm:p-8 max-w-lg w-full relative" style={{ borderColor: "rgba(231,180,59,.45)" }}>
        <button onClick={() => setOpen(false)}
          className="absolute top-3 right-3 w-9 h-9 rounded-full grid place-items-center border border-[#23232a] hover:border-[color:var(--gold)]" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
        <div className="w-12 h-12 rounded-xl grid place-items-center mb-4 sm:mb-5" style={{ background: "linear-gradient(135deg,#f5d06a,#8a6a15)" }}>
          <Gift className="w-6 h-6 text-[#141006]" />
        </div>
        <h3 className="font-display font-black text-2xl sm:text-3xl lg:text-4xl mt-3 leading-tight">
          {fmtCcy(currency.price)} → {fmtCcy(currency.mrp)}
        </h3>
        <p className="text-[13px] sm:text-sm text-[color:var(--ink-dim)] mt-3 leading-relaxed">{t("final_sub")}</p>
        <button onClick={() => { setOpen(false); goToCheckout(currency.code, currency.price); }} data-testid="exit-intent-cta"
          className="btn-gold mt-5 sm:mt-6 w-full h-12 rounded-full font-display text-sm">
          {t("pricing_cta")} →
        </button>
      </div>
    </div>
  );
}
